export default __webpack_public_path__ + "static/media/12.d5ac2012.png";